<template>
  <b-form @submit="onSubmit" v-bind:validated="formSubmitted">
    <b-row>
      <b-col>
        <b-form-group
            label="Référence du marché :">
            {{dispense.referenceMarche}}
        </b-form-group>
      </b-col>
    </b-row>
      <b-row>
          <b-col>
              <b-form-group
                  id="input-group-date-debut"
                  label="Date de début"
                  label-for="input-date-debut">
                <vue-monthly-picker
                    id="input-date-debut"
                    dateFormat="MM/YYYY"
                    :monthLabels="monthLabels"
                    v-model="momentDebut">
                </vue-monthly-picker>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group
                  id="input-group-date-fin"
                  label="Date de fin"
                  label-for="input-date-fin">
                <vue-monthly-picker
                    id="input-date-fin"
                    dateFormat="MM/YYYY"
                    :monthLabels="monthLabels"
                    v-model="momentFin">
                </vue-monthly-picker>
                <div class="typo-warning" v-if="isBeforeDate()">
                  la date de fin doit être postérieure à la date de début
                </div>
              </b-form-group>
          </b-col>
      </b-row>
      <b-row>
          <b-col>
            <b-form-group
                id="input-group-type"
                label="Type"
                label-for="input-type">
              <b-form-select
                  id="input-type"
                  v-model="dispense.type">
                <b-form-select-option :value="'ADMINISTRATEUR'">
                  ADMINISTRATEUR
                </b-form-select-option>
                <b-form-select-option :value="'UTILISATEUR'">
                  UTILISATEUR
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
              id="input-group-ongletReporting"
              label="Onglet"
              label-for="input-ongletReporting">
          </b-form-group>
          <b-form-select
              id="input-ongletReporting"
              v-model="dispense.ongletReporting">
            <b-form-select-option :value="'EMPREINTE'">
              EMPREINTE
            </b-form-select-option>
            <b-form-select-option :value="'EFFECTIFS'">
              EFFECTIFS
            </b-form-select-option>
            <b-form-select-option :value="'ACCIDENTOLOGIE'">
              ACCIDENTOLOGIE
            </b-form-select-option>
            <b-form-select-option :value="'GPEC_PREVISIONNEL'">
              GPEC_PREVISIONNEL
            </b-form-select-option>
            <b-form-select-option :value="'GPEC_REALISE'">
              GPEC_REALISE
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
          <b-col>
            <b-form-group
                id="input-group-commentaire"
                label="Commentaire"
                label-for="input-commentaire">
                <b-form-input
                        id="input-commentaire"
                        v-model="dispense.commentaire"
                        type="text"
                        maxlength="200"
                        :trim="true"
                        >
                </b-form-input>
            </b-form-group>
          </b-col>
      </b-row>
      <b-row class="pt-2" align-h="center">
        <b-button type="submit" variant="primary" @click="formSubmitted= true" v-if="!isBeforeDate()">
          Modifier
        </b-button>
      </b-row>
  </b-form>
</template>

<script>

  import VueMonthlyPicker from "vue-monthly-picker";
  import DispenseReportingDto from "@/dtos/DispenseReportingDto";
  import {mois} from "@/constants/enums";
  import moment from 'moment';
  import ReportingStore from "@/stores/ReportingStore";
  import {momentToDate} from "../../utils/dateUtil";

  export default {
    name: "ModifierReportingDispenses",
    components: {VueMonthlyPicker},
    props: {
      modalId: {
        type: String
      },
      value: {}
    },
    data() {
      return {
        dispense: new DispenseReportingDto(),
        formSubmitted: false,
        monthLabels: mois,
        momentDebut: null,
        momentFin: null
      }
    },
    watch: {
      value: function (dispense) {
        this.initDispense(dispense);
      }
    },
    mounted() {
      this.initDispense(this.value);
    },
    methods: {
      initDispense(dispense) {
        if (dispense) {
          this.momentDebut = moment(dispense.dateDebut, 'DD/MM/YYYY');
          this.momentFin = moment(dispense.dateFin,  'DD/MM/YYYY');
          this.dispense = Object.assign({}, dispense);
        } else {
          this.dispense = new DispenseReportingDto();
        }
      },
      isBeforeDate() {
        if (this.momentDebut && this.momentFin) {
          return this.momentFin.isBefore(this.momentDebut)
        }
        return false;
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.dispense.dateDebut = this.momentDebut ? momentToDate(this.momentDebut) : null;
        this.dispense.dateFin = this.momentFin ? momentToDate(this.momentFin) : null;
        ReportingStore.update(this.dispense).then(() => {
          this.$root.$emit('bv::hide::modal', this.modalId);
        });
      },
    }
  }

</script>